// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, veriffStartVerification } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetStartVerificationVeriff = createAsyncThunk(
  "hitGetStartVerificationVeriff",
  async ({ firstName, lastName, email, type }) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken") ? localStorage.getItem("professionalToken") : localStorage.getItem("clientToken")}`,
        },
        params: {
          firstName: firstName,
          lastName: lastName,
          email: email,
          id: localStorage.getItem("professionalId") ? localStorage.getItem("professionalId") : localStorage.getItem("clientId"),
          type: type
        },
      };
      const url = ApiBaseUrl + veriffStartVerification;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const VeriffStartVerificationSlice = createSlice({
  name: "veriffStartVerificationReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearVeriffDataData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetStartVerificationVeriff.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetStartVerificationVeriff.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetStartVerificationVeriff.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearVeriffDataData } = VeriffStartVerificationSlice.actions;
export default VeriffStartVerificationSlice.reducer;
